export const getViewabilityEvent = (
    container,
    pathname,
    ignoreViews,
    name,
    type,
    journeyGroupType,
    sequenceId
) => ({
    'data-v-group': JSON.stringify({
        name: container,
        type: journeyGroupType,
    }),
    'data-v-event': JSON.stringify({
        category: 'viewability',
        action: ignoreViews ? 'select' : 'view',
        entity_name: 'item',
        grouping: 'account-journey',
        sequence_id: sequenceId,
    }),
    'data-v-item': JSON.stringify({
        name,
        type,
    }),
    'data-bbc-ignore-views': ignoreViews ? '1' : undefined,
});
